<!-- 登录组件 -->
<template>
  <div class="wrap" v-if="visible">
    <div class="download">
      <div class="text-title">
        <slot name="title">{{ $t('downloadTip.title') }}</slot>
      </div>
      <div class="text-btn" @click.stop="gotoApp">{{ $t('downloadTip.textBtn') }}</div>
    </div>
    <div class="mask" @click.stop="hide"></div>
    <div id='mask' v-if="isMask" @click="isMask=false">
      <img src="http://static.lespark.cn/activity/img/mark.png" alt="">
    </div> 
  </div>
</template>

<script>
import Util from 'Common/util.js';

export default {
  name: 'downloadTip',
  props: {
  },
  data() {
    return {
      visible: false,
      isMask:false,
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    },
    gotoApp () {
      var weixin = navigator.userAgent.indexOf('MicroMessenger') > -1 //是否为微信浏览器
      var qq = navigator.userAgent.match(/\sQQ/i) !== null //是否QQ
      if (weixin || qq) {
        this.isMask = true
        return
      }
      Util.gotoApp()
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap {
  display: flex;
  justify-content: center;
  width: 100vw;
  .download {
    /* height: 40.05333vw; */
    background: #ffffff;
    border-radius: 3.2vw;
    position: absolute;
    top: 52.13333vw;
    z-index: 2;
    .text-title {
      max-width: 63.2vw;
      font-size: 4.8vw;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 5.73333vw;
      margin: 8vw 8.4vw;
    }
    .text-btn {
      width: 23.2vw;
      font-size: 4.8vw;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #4498fb;
      line-height: 4.8vw;
      border-top: 1px solid #dddddd;
      width: 100%;
      text-align: center;
      padding: 4.13333vw 0;
    }
  }
}
.mask {
  position: fixed;
  background: rgba(0, 0, 0, 0.4);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
}
#mask {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background: rgba(0, 0, 0, 1);
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  img {
    width: 85%;
    position: absolute;
    top: 0;
    right: 0
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/downloadTip.vue